module.exports = __webpack_public_path__ + "img/Cinema4d.1b980e8a.png";